import React, { useEffect, useState } from "react";
const { forwardRef, useRef, useImperativeHandle } = React;

const CurrencyInput = forwardRef(
  ({ placeholder, onChange, name, inputValue }, ref) => {
    const [value, setValue] = useState();

    useImperativeHandle(ref, () => ({
      afterSubmit() {
        setValue(addCommas(removeNonNumeric('')));
      },
    }));

    const addCommas = (num) =>
      num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

    const handleChange = (event) => {
      setValue(addCommas(removeNonNumeric(event.target.value)));
      onChange(removeNonNumeric(event.target.value));
    };

    useEffect(() => {
      if (inputValue) {
        setValue(addCommas(removeNonNumeric(inputValue)));
      }
    }, [inputValue]);

    return (
      <div className="App">
        <input
          type="text"
          autocomplete="off"
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          className="backdrop-blur block  px-4 py-[7px] w-full blocktext-sm text-gray-900 bg-gray-50/50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700/70 dark:border-s-gray-700/70  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500  outline-none"
        />
      </div>
    );
  }
);

export default CurrencyInput;
